// Brief 85 §2 — ArbiterModal, moved out of App.tsx's renderModals switch.
//
// MOVED, NOT REWRITTEN. The body below is byte-identical to the `case "ar":`
// clause it left —
//   sha256 6b9a1fcfacda785da389b8339d56a18249243c6aa10a022bfbd7276087853f49
// — including its original indentation, which is why it sits deeper than this
// file's own wrapper. Only the imports, the Props type, the signature and the
// `return (` / `);` are new.
// Do not reformat: the indentation IS the proof.
//
// Props are the UNION of the names the body actually read in App scope, taken
// from a TypeScript-checker walk rather than chosen — a passed-but-unread prop
// would mean the union rule absorbed something it should have refused.
// The vocabulary props are typed by inference off makeModalFields' return, so
// this file adds nothing to the `any` ratchet.

import AddressFields from "./AddressFields";
import { ModalLayout } from "../SharedUI";
import { SK } from "../../utils";
import type { TaxList, TFn } from "../../lib/taxonomyTypes";
import type { FieldSelectOption } from "../FieldSelect";
import type { makeModalFields } from "../modalFields";

type Vocab = ReturnType<typeof makeModalFields>;
type ModalForm = { country?: string | null; id?: string | null };

type Props = {
  BarAssoc: Vocab["BarAssoc"];
  F: Vocab["F"];
  NA: Vocab["NA"];
  T: Vocab["T"];
  TitSel: Vocab["TitSel"];
  _fl: Vocab["_fl"];
  _mt: Vocab["_mt"];
  arbiters: readonly unknown[];
  cm: () => void;
  countriesList: readonly FieldSelectOption[];
  countryEntries: TaxList;
  form: ModalForm;
  saveEntity: (k: string, rows: readonly unknown[], set: (v: readonly unknown[]) => void, f: unknown, ext?: Record<string, unknown>) => void;
  setArbiters: (v: readonly unknown[]) => void;
  t: TFn;
  updateField: (k: string, v: string) => void;
};

export default function ArbiterModal({
  BarAssoc,
  F,
  NA,
  T,
  TitSel,
  _fl,
  _mt,
  arbiters,
  cm,
  countriesList,
  countryEntries,
  form,
  saveEntity,
  setArbiters,
  t,
  updateField,
}: Props) {
  return (
          <ModalLayout
            recordId={form.id} // 204 §G — the person's internal id in the header
            title={form.id ? _mt("Edit Arbiter") : _mt("New Arbiter")}
            onClose={cm}
            onSave={() =>
              saveEntity(SK.ar, arbiters, setArbiters, form, { country: form.country || null })
            }
          >
              <>
                <div className="field-row">
                  {TitSel}
                  {F("First Name *", "firstName", "", 1)}
                </div>
                <div className="field-row">
                  {F("Last Name *", "lastName")}
                  {F("Specialty", "specialty")}
                </div>
                {NA({
                  pool: arbiters,
                  typeLabel: t("type.arbiter", { fallback: "arbiter" }),
                })}
                {F("Chamber", "firm")}
                <div className="field-row">
                  {F("Email", "email")}
                  {F("Phone", "phone")}
                </div>
                {BarAssoc}
                <AddressFields
                  F={F}
                  _fl={_fl}
                  countriesList={countriesList}
                  countryEntries={countryEntries}
                  form={form}
                  t={t}
                  updateField={updateField}
                />
                {T("Notes", "notes")}
              </>
          </ModalLayout>
  );
}
